import { useState } from 'react';

const calcLastPossibleIndex = collectionSize => Math.max(0, collectionSize - 1);

const useArrows = (initialIndex = 0, collectionSize) => {
    const [index, setIndex] = useState(initialIndex);
    const lastPossibleIndex = calcLastPossibleIndex(collectionSize);

    return {
        index,
        setIndex,
        leftDisabled: index === 0,
        rightDisabled: index === lastPossibleIndex
    };
};

export default useArrows;
